import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";


@Injectable({
    providedIn: 'root',
})
export class MenuService {
    public goToAnchorSubject: Subject<string> = new Subject<string>();
    public goToAnchorObservable: Observable<string> = this.goToAnchorSubject.asObservable();

}